import {
  type AgreeInsuranceToTermsMutationVariables,
  useAgreeInsuranceToTermsMutation,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useUpdateInsuranceTerms = () => {
  const [updateInsuranceTermsMutation] = useAgreeInsuranceToTermsMutation({
    context: {
      apiVersion: AppApiVersions.core,
    },
  });

  const updateInsuranceTerms = (
    variables: AgreeInsuranceToTermsMutationVariables,
  ) =>
    updateInsuranceTermsMutation({
      variables,
    });

  return {
    updateInsuranceTerms,
  };
};
